import l18n from '../shared/strings';

/** Matches server-side collectionName regexp (server/app/schemas/regexp/collectionName.js). */
export const COLLECTION_NAME_PATTERN = /^[\p{L}0-9 _()!?'&,.*+@#$%^=`\-–—]+$/u;

/**
 * @param {string} value
 * @returns {string|null} Tooltip message when invalid, otherwise null.
 */
export function getCollectionNameValidationError(value) {
  if (!value) return null;
  if (value.startsWith('.')) return l18n.COLLECTION_NAME_INVALID_CHARS_TOOLTIP;
  if (!COLLECTION_NAME_PATTERN.test(value)) return l18n.COLLECTION_NAME_INVALID_CHARS_TOOLTIP;
  return null;
}

/**
 * @param {string} value
 * @param {string[]} alreadyUsedNames - normalized names
 * @param {(name: string) => string} normalizeName
 * @returns {true|false|string}
 */
export function validateCollectionTreeItemName(value, alreadyUsedNames, normalizeName) {
  const charError = getCollectionNameValidationError(value);
  if (charError) return charError;
  if (!value || alreadyUsedNames.includes(normalizeName(value))) return false;
  return true;
}

/**
 * Validates a collection name against child or sibling names (CollectionsTree/Item).
 * @param {string} value
 * @param {object} options
 * @param {string[]} options.childNames - normalized child names
 * @param {string[]} options.siblingNames - normalized sibling names
 * @param {boolean} options.isRename - when true, checks siblings instead of children
 * @param {(name: string) => string} normalizeName
 * @returns {true|false|string}
 */
export function validateCollectionTreeChildOrSiblingName(
  value,
  { childNames, siblingNames, isRename },
  normalizeName,
) {
  const charError = getCollectionNameValidationError(value);
  if (charError) return charError;

  const names = isRename ? siblingNames : childNames;
  if (!value || names.includes(normalizeName(value))) return false;
  return true;
}
